import {createAsyncThunk} from '@reduxjs/toolkit';
import {
  adminConfigurationService,
} from '../services/admin-configuration-service';
import {RootState} from '../../shared/state/root-reducer';
import {
  showErrorStatus,
} from '../../security/state/user-slice';
import {Utils} from '../../shared/utils';

export const configGetLOC = createAsyncThunk(
  "adminConfigurationContext/configGetLOC",
  async (paramId: number, thunkAPI) => {
    const response = await adminConfigurationService.configGetLOC(paramId);
    if (response.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(response.errorMessage));
    } else {
      return response.entity;
    }
  }
);

export const configGetPayers = createAsyncThunk(
  "adminConfigurationContext/configGetPayers",
  async (paramId: number, thunkAPI) => {
    const response = await adminConfigurationService.configGetPayers(paramId);
    if (response.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(response.errorMessage));
    } else {
      return response.entity;
    }
  }
);

export const configGetScholarships = createAsyncThunk(
  "adminConfigurationContext/configGetScholarships",
  async (data: {paramId: number, clientId: number}, thunkAPI) => {
    const response = await adminConfigurationService.configGetScholarships(data.paramId, data.clientId);
    if (response.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(response.errorMessage));
    } else {
      return response.entity;
    }
  }
);

export const configGetRiskThresholds = createAsyncThunk(
  "adminConfigurationContext/configGetRiskThresholds",
  async (data: {paramId: number}, thunkAPI) => {
    const response = await adminConfigurationService.configGetRiskThresholds(data.paramId);
    if (response.hasErrors) {
      thunkAPI.dispatch(showErrorStatus(response.errorMessage));
    } else {
      return response.entity;
    }
  }
);

export const configGetRiskClassSettings = createAsyncThunk(
  "adminConfigurationContext/configGetRiskClassSettings",
  async (data: {paramId: number}, thunkAPI) => {
    const state = thunkAPI.getState() as RootState;
    const finPayRiskClasses = state.adminContext.adminConfigurationContext.finPayRiskClasses;

    const response = await adminConfigurationService.configGetRiskClassSettings(data.paramId, finPayRiskClasses);

    if (response.hasErrors) {
      Utils.robustErrorHandler(response, thunkAPI);
    } else {
      return response.entity;
    }
  }
);


export const configGetFinPayRiskClasses = createAsyncThunk(
  "adminConfigurationContext/configGetFinPayRiskClasses",
  async (data: {paramId: number}, thunkAPI) => {
    const response = await adminConfigurationService.configGetFinPayRiskClasses(data.paramId);

    if (response.hasErrors) {
      Utils.robustErrorHandler(response, thunkAPI);
    } else {
      return response.entity;
    }
  }
);
